import { createAction } from 'react-async-client';

import { SIDEBAR_OPEN, SIDEBAR_LOCK, SIDEBAR_CLOSE } from 'constants/actionTypes';

export const sidebarOpen = createAction(SIDEBAR_OPEN);
export const sidebarLock = createAction(SIDEBAR_LOCK);
export const sidebarClose = createAction(SIDEBAR_CLOSE);
